<script>
  import { modal, checkbox, radio } from 'vue-strap';
  import ListaRateioDespesasRubricas from './ListaRateioDespesasRubricas.vue';
  import Totalizador from './Totalizador.vue';
  
  export default {
    components: { modal, checkbox, radio, ListaRateioDespesasRubricas, Totalizador },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      permitirDeclaracao: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        rateio: this.camposRateio(),
        rubricas: [],
        subrubricas: [],
        mostrarModalRateio: false, 
        indiceSelecionado: null,
        valorNaoUtilizado: false,
        tipoDocumento: 'cnpj',
      }
    },
    methods: {
      camposRateio() {
        return {
          idSolicitacaoAdiantamentoDespesaViagemRateio: null,
          idSolicitacaoAdiantamentoDespesaViagem: null,
          cpfCnpj: '',
          nome: null,
          valor: null,
          validade: null,
          observacao: null,
          observacaoAnalise: null,
          valorValidado: null,
        }
      },
      validar() {        
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      adicionar() {
        const copiaRateio = Object.assign(this.rateio);
        
        if (this.valorNaoUtilizado) {
          copiaRateio.observacao = 'VALOR NÃO UTILIZADO';
        }
        
        copiaRateio.idSolicitacaoAdiantamentoDespesaViagem = this.solicitacao.despesasViajem[this.indiceSelecionado].idSolicitacaoAdiantamentoDespesaViagem;
        
        this.solicitacao.despesasViajem[this.indiceSelecionado].rateios.push(copiaRateio);

        this.rateio = this.camposRateio();
        this.$validator.reset();
        this.valorNaoUtilizado = false;
        
        this.mostrarModalRateio = false;
      },
      limparDocumento() {
        this.rateio.cpfCnpj = '';
      },
    },
    computed: {
      
    },
    watch: {
      'tipoDocumento': 'limparDocumento'
    }
  }
</script>

<template>
  <div>

    <div class="bs-callout bs-callout-info no-margin-top" v-for="(despesa, index) in solicitacao.despesasViajem">

      <h4>
        Item #{{ index + 1 }}
      </h4>

      <div class="row">
        <dl class="col-md-4">
          <dt>Rubrica</dt>
          <dd>{{ despesa.rubrica.nome }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Subrubrica</dt>
          <dd>{{ despesa.subrubrica.nome }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Valor</dt>
          <dd>{{ despesa.valorSolicitado }}</dd>
        </dl>
      </div>

      <div class="row" v-if="despesa.observacao">
        <dl class="col-md-12">
          <dt>Observação</dt>
          <dd>{{ despesa.observacao }}</dd>
        </dl>
      </div>
      
      <lista-rateio-despesas-rubricas 
        :rateios="despesa.rateios"
        :declaracaoIniciada="!permitirDeclaracao">
      </lista-rateio-despesas-rubricas>
      
      <div class="row" v-if="permitirDeclaracao">
        <div class="col-md-12">
          <button type="button" class="btn btn-success" @click="mostrarModalRateio = true, indiceSelecionado = index, $events.$emit('desativarAnimacao')">
            <i class="fa fa-plus"></i> Adicionar despesa
          </button>
        </div>
      </div>

    </div>
    
    <totalizador 
      :solicitacao="solicitacao">
    </totalizador>

    <modal v-model="mostrarModalRateio" effect="fade" @closed="" :large="true" cancel-text="Fechar"
           ok-text="Adicionar despesa" title="Declaração de despesa" @ok="validar">

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <checkbox v-model="valorNaoUtilizado" type="success">Valor não utilizado</checkbox>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('documentoRateio')}">
            <label class="control-label radios" for="documento-rateio" style="margin-bottom: 3px">
              <radio
                style="margin-right: 10px"
                v-model="tipoDocumento"
                selected-value="cpf"
                :disabled="valorNaoUtilizado"
                type="success">
                CPF
              </radio>
              <radio
                v-model="tipoDocumento"
                selected-value="cnpj"
                :disabled="valorNaoUtilizado"
                type="success">
                CNPJ
              </radio>
            </label>

            <input
              type="text"
              class="form-control"
              id="documento-rateio"
              v-model="rateio.cpfCnpj"
              data-vv-name="documentoRateio"
              data-vv-as="CPF/CNPJ"
              v-validate="!valorNaoUtilizado ? `required|${tipoDocumento}` : ''"
              :disabled="valorNaoUtilizado"
              v-mascara="tipoDocumento">
  
            <p class="text-danger" v-show="errors.has('documentoRateio')">{{ errors.first('documentoRateio') }}</p>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('nomeRateio')}">
            <label class="control-label" for="nome-rateio">Pessoa/Empresa</label>

            <input
              type="text"
              class="form-control"
              id="nome-rateio"
              v-model="rateio.nome"
              data-vv-name="nomeRateio"
              data-vv-as="Pessoa/Empresa"
              v-validate="!valorNaoUtilizado ? 'required' : ''"
              :disabled="valorNaoUtilizado"
              maxlength="150">
  
            <p class="text-danger" v-show="errors.has('nomeRateio')">{{ errors.first('nomeRateio') }}</p>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="form-group required" :class="{'has-error': errors.has('valorRateio')}">
            <label class="control-label" for="valor-rateio">Valor</label>

            <input
              type="text"
              class="form-control text-right"
              id="valor-rateio"
              v-model="rateio.valor"
              data-vv-name="valorRateio"
              data-vv-as="Valor"
              v-validate="!valorNaoUtilizado ? 'required' : ''"
              v-mascara="'moeda'"
              :disabled="valorNaoUtilizado">
  
            <p class="text-danger" v-show="errors.has('valorRateio')">{{ errors.first('valorRateio') }}</p>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label" for="obs-rateio">Observação</label>

            <input
              type="text"
              class="form-control"
              id="obs-rateio"
              v-model="rateio.observacao"
              :disabled="valorNaoUtilizado"
              maxlength="150">
          </div>
        </div>
      </div>
      
    </modal>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/FormDeclararDespesasRubricas.vue